import type { ApiFailure } from '@/core/either';
import {
  HTTP_STATUS_TOO_MANY_REQUESTS,
  OTP_THROTTLING_REASONS,
} from '../constants/otpThrottling.constant';

/**
 * Dice si el envío del código falló porque el backend limitó los pedidos.
 * Recibe `unknown` porque los `catch` de `useOtp` también atrapan errores que
 * no son `ApiFailure`, como los de render del recaptcha.
 */
export function isOtpThrottlingFailure(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;

  const { reason, status } = error as Partial<ApiFailure>;
  if (status === HTTP_STATUS_TOO_MANY_REQUESTS) return true;
  return typeof reason === 'string' && OTP_THROTTLING_REASONS.has(reason);
}
